<template>
    <div id="view">
        <div class="box">
            <div id="title" class="title has-text-grey-dark"><i class="fa fa-users"></i> Users</div>
        </div>
        <hr>
        <div class="box columns is-multiline">
            <div class="column is-12">
              <router-link v-bind:to="{name: 'add-user' }" class="button is-info is-pulled-right">Add new</router-link>
            </div>
            <div class="column">
                <users-table :page="page" @search="onSearch" @sort="onOrderBy" @pageChanged="onPageChanged" :total="total" v-bind:items="users" v-bind:actions="true"></users-table>
            </div>
        </div>          
    </div>  
</template>

<script>
import UserRepo from '../../repos/UserRepo'
import lodash from 'lodash'
import UsersTable from "./Table";

export default {
  name: 'users-view',
  components: {UsersTable},
  data() {
        return {
            repo: new UserRepo(this.$auth),
            users: [],
            total: 0,
            q: '',
            orderBy: 'id,asc',
            page: 1,
        }
  },
  created(){
    this.getUsers();
  },
  methods: {
    onSearch(q){
        this.page = 1;
        this.q = q;
        this.getUsers();
    },
    onOrderBy(orderBy){
        this.page = 1;
        this.orderBy = orderBy;
        this.getUsers();
    },
    onPageChanged(page){
        this.page = page;        
        this.getUsers();
    },
    getUsers(){
        this.repo.paginate(this.page, this.q, this.orderBy).then(response => {            
            this.users = response.data.data; 
            this.total = response.data.meta.pagination.total_pages            
        });         
    },
  },
  watch: {
       
  }
  
}
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/users/View.vue